module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/quote-2-d4e844a8f383e11ae190534b5b294c13.svg";